import React from 'react'
import { Table, TableBody, TableCell, TableCellProps, TableContainer, TableHead, TableRow, makeStyles } from '@material-ui/core'

export const EasyTable = <T extends unknown>({
  data,
  columns,
}: {
  data: T[]
  columns: IEasyTableColumn<T>[]
}) => {
  const { headerRow } = useStyles()

  return <TableContainer>
    <Table size="small">
      <TableHead>
        <TableRow className={headerRow}>
          { columns.map((col, i) => <TableCell key={i} {...col.cellProps}>{col.title}</TableCell>) }
        </TableRow>
      </TableHead>
      <TableBody>
        { data.map((r, i) => <TableRow key={i}>
          { columns.map((col, j) => <TableCell key={j} {...col.cellProps}>{ col.value(r) }</TableCell>) }
        </TableRow>) }
      </TableBody>
    </Table>
  </TableContainer>
}

export interface IEasyTableColumn<T = any> {
  title: string
  value(row: T): any
  cellProps?: Partial<TableCellProps>
}

const useStyles = makeStyles({
  headerRow: {
    fontWeight: 'bold',

    '& > th': {
      fontWeight: 'bold',
    },
  },
})
